import { SERVER_API_URL } from '../../app.constants';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { Principal } from 'src/app/core/auth/principal.service';



// type NewType = EntityResponseType;

@Injectable({ providedIn: 'root' })
export class ConfirmationModelService {
    fromEffectiveDateFormatted : string;
    private resourceUrl = SERVER_API_URL + 'api/find-existed-future-record-details';
    
    private deletionUrl = SERVER_API_URL + 'api/delete-existed-future-record-details';

    private changeStatusUrl = SERVER_API_URL + 'api/update-existed-future-record-status';


    constructor(private http: HttpClient,private principal: Principal) {
        this.fromEffectiveDateFormatted = this.principal.dateFormateClientToServerCDate();
    }

    findFutureRecordExisted(form_data): Observable<any> {
        return this.http.post<any>(this.resourceUrl, form_data, { observe: 'response' })
    }

    deleteExistedFutureRecord(form_data): Observable<any> {
        return this.http.post<any>(this.deletionUrl, form_data, { observe: 'response' });
    }

    updateExistedFutureRecordStatus(form_data): Observable<any> {
        form_data.fromEffectiveDateFormatted = this.fromEffectiveDateFormatted;
        console.log(form_data);
        return this.http.put<any>(this.changeStatusUrl, form_data, { observe: 'response' });
    }

}
